import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card, Table, Modal } from "react-bootstrap";
import {
  getEnrolledEmployees,
  approveEnrollment,
} from "../../redux/capacitacionDesarrollo/Enrollment/actions";

const CourseApprovals = () => {
  // Estados
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedEnrollment, setSelectedEnrollment] = useState(null);
  const [isApproving, setIsApproving] = useState(false);

  // Store
  const username = useSelector((store) => store.auth.username);
  const { loaderEnrolledEmployees, enrolledEmployees, enrolledEmployeesFail } =
    useSelector((store) => store.CoursesEnrollment);

  useEffect(() => {
    if (username) {
      dispatch(getEnrolledEmployees(username));
    }
  }, [dispatch, username]);

  // Manejadores de eventos
  const handleApproveClick = (enrollment) => {
    setSelectedEnrollment(enrollment);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEnrollment(null);
  };

  const handleConfirmApproval = async () => {
    if (!selectedEnrollment || !username) return;

    setIsApproving(true);

    try {
      const approvalData = {
        codigo_jefe: username,
        matricula_id: selectedEnrollment.matricula_id,
      };

      await dispatch(approveEnrollment(approvalData));

      dispatch(getEnrolledEmployees(username));

      handleCloseModal();
    } catch (error) {
    } finally {
      setIsApproving(false);
    }
  };

  return (
    <>
      <Card>
        <Card.Body>
          <h5>
            Empleados Pendientes de Aprobación (
            {enrolledEmployees?.total_pendientes || 0})
          </h5>

          {loaderEnrolledEmployees ? (
            <p>Cargando...</p>
          ) : enrolledEmployeesFail ? (
            <div className="alert alert-danger">{enrolledEmployeesFail}</div>
          ) : enrolledEmployees?.matriculas_pendientes?.length === 0 ? (
            <div className="alert alert-info">
              No hay ningún colaborador pendiente para aprobación
            </div>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>Fecha Matrícula</th>
                  <th>Curso</th>
                  <th>Fecha Inicio</th>
                  <th>Duración (horas)</th>
                  <th>Instructor</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {enrolledEmployees?.matriculas_pendientes?.map((enrollment) => (
                  <tr key={enrollment.matricula_id}>
                    <td>{enrollment.empleado.codigo}</td>
                    <td>{enrollment.empleado.nombre}</td>
                    <td>
                      {new Date(
                        enrollment.fecha_matricula
                      ).toLocaleDateString()}
                    </td>
                    <td>{enrollment.curso.nombre}</td>
                    <td>
                      {new Date(
                        enrollment.curso.fecha_inicio_curso
                      ).toLocaleDateString()}
                    </td>
                    <td>{enrollment.curso.duracion_horas}</td>
                    <td>{enrollment.curso.instructor}</td>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleApproveClick(enrollment)}
                        disabled={loaderEnrolledEmployees}
                      >
                        Aprobar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Aprobación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEnrollment && (
            <>
              <p>
                ¿Desea aprobar la matrícula de{" "}
                <strong>{selectedEnrollment.empleado.nombre}</strong> al curso{" "}
                <strong>{selectedEnrollment.curso.nombre}</strong>?
              </p>
              <p>
                <strong>Fecha de inicio:</strong>{" "}
                {new Date(
                  selectedEnrollment.curso.fecha_inicio_curso
                ).toLocaleDateString()}
                <br />
                <strong>Duración:</strong>{" "}
                {selectedEnrollment.curso.duracion_horas} horas
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            disabled={isApproving}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmApproval}
            disabled={isApproving}
          >
            {isApproving ? "Aprobando..." : "Confirmar Aprobación"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CourseApprovals;
